/**
 * Card types on the team home workspace that require execute results (charts / widgets).
 * Keep in sync with useHomeWorkspaceCanvas missing-results logic.
 */
export const HOME_ANALYTIC_TYPES = new Set([
  'insights',
  'funnel',
  'flow',
  'retention',
  'team_widget',
]);
